import classnames from 'classnames';
import moment from 'moment';
import React from 'react';

import { PopupBuilderNewsletterContentSection } from '../contentTypes';
import { Countdown } from '../Countdown';
import { Div } from '../HTMLElement';
import { useCountdown } from '../useCountdown';
import { buildVisibilityClassNamesFromContent } from '../util';
import { PropsWithCustomComponent, VariantsController } from '../VariantsController';

export interface PopupBuilderCountdownComponentProps extends PopupBuilderNewsletterContentSection {
  expiration: Date;
}

const PopupBuilderCountdownComponent = ({ expiration, options }: PopupBuilderCountdownComponentProps) => {
  const date = React.useMemo(() => new Date(moment.utc(expiration).toDate()), [expiration]);
  const visibility = options?.visibility;
  const visibilityClassNames = visibility && buildVisibilityClassNamesFromContent(visibility);

  const handleComplete = React.useCallback(() => {
    console.log('complete');
  }, []);

  const countdown = useCountdown(date, {
    onComplete: handleComplete,
  });

  return (
    <Div
      className={classnames('popup-builder-countdown-component', options?.classes)}
      display={'flex'}
      justifyContent={'center'}
      uiClassName={{ bs5: visibilityClassNames }}
    >
      {!countdown?.completed && (
        <Countdown
          days={countdown?.days ?? 0}
          hours={countdown?.hours ?? 0}
          minutes={countdown?.minutes ?? 0}
          seconds={countdown?.seconds ?? 0}
        />
      )}
    </Div>
  );
};

export type PopupBuilderCountdownComponentVariants = '';

const PopupBuilderCountdownComponentController = (
  props: PropsWithCustomComponent<PopupBuilderCountdownComponentProps>
) => (
  <VariantsController<PopupBuilderCountdownComponentProps, PopupBuilderCountdownComponentVariants>
    {...props}
    variantsControllerConfig={{
      defaultComponent: PopupBuilderCountdownComponent,
      name: 'PopupBuilderCountdownComponent',
    }}
  />
);
export { PopupBuilderCountdownComponentController as PopupBuilderCountdownComponent };
